import { isBitiba } from '@zooplus/commons-lang';
import { P2 } from '@zooplus/ui-components';

import { getAppConfig } from '@config/get-app-config';
import { useTranslation } from '@hooks/use-translations';
import { LEGAL_LINK, COPYRIGHT_TEXT } from '@utilities/constants';

import styles from './minimalist-footer.module.scss';

const MinimalistFooter = () => {
  const { t } = useTranslation();
  const { site } = getAppConfig();

  return (
    <footer className={styles.minimalistFooterWrapper}>
      <div className={styles.footerLinks}>
        <a href={LEGAL_LINK.IMPRINT} data-testid="imprint-text-link">
          <P2>{t('checkout.footer.imprint')}</P2>
        </a>
        <a href={LEGAL_LINK.PRIVACY} data-testid="privacy-text-link">
          <P2>{t('checkout.footer.privacy')}</P2>
        </a>
      </div>
      <P2 data-testid="copyright-text">
        {isBitiba(site.domain) ? COPYRIGHT_TEXT.BITIBA : COPYRIGHT_TEXT.ZOOPLUS}{' '}
        {new Date().getFullYear()}
      </P2>
    </footer>
  );
};

export default MinimalistFooter;
